<template>
  <v-card>
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('label.search')"
            dense
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="payments"
        :search="search"
        :loading="isLoading"
        :options="options"
      ></v-data-table>
      <v-row justify="end">
      <v-col cols="3">
        <!-- <h1>{{ $t('label.total') }} $17000</h1> -->
      </v-col>
    </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { extractDateTime, formatDateTime } from '../../../core/sharedFunctions'
import { loading, showMessage } from '../../../mixins'

export default {
  name: 'PaymentsList',
  mixins: [loading, showMessage],
  data: () => ({
    payments: [],
    search: '',
    options: {
      // sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 10
    }
  }),
  computed: {
    headers () {
      const headers = [
        { text: this.$t('label.invoiceNumber'), value: 'invoiceNumber', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.invoiceReference'), value: 'invoiceReference', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.paymentDate'), value: 'paymentDate', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.currency'), value: 'currency', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.amount'), value: 'amount', align: 'center', sortable: true, filterable: true }
      ]
      return headers
    }
  },
  methods: {
    getPayments () {
      this.changeLoadingStatus(true)
      this.$proxy.get('api/purchaseOrders/payments')
        .then((r) => {
          this.payments = r.data.map(p => {
            p.paymentDate = formatDateTime(extractDateTime(p.paymentDate))
            return p
          })
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    }
  },
  mounted () {
    this.getPayments()
  }
}
</script>

<style>

</style>
